import { render } from "./ArchivedUser.vue?vue&type=template&id=65d50bf5&scoped=true"
import script from "./ArchivedUser.vue?vue&type=script&lang=js"
export * from "./ArchivedUser.vue?vue&type=script&lang=js"

import "./ArchivedUser.vue?vue&type=style&index=0&id=65d50bf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d50bf5"]])

export default __exports__